import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShippingsContextService {

  private subject = new Subject<{context: string, clientId: string, siteId: string, shippingId: string}>();

  constructor() { }

  sendContext(message: {context: string, clientId: string, siteId: string, shippingId: string}): void {
    this.subject.next( message );
  }

  clearContext(): void {
    this.subject.next();
  }

  getContext(): Observable<{context: string, clientId: string, siteId: string, shippingId: string}> {
    return this.subject.asObservable();
  }
}
